module.exports = __webpack_public_path__ + "static/media/arrow-up-small-inc.cb47c0f0.svg";